const getTeamType = (match, teamId) => {
    const isLocal = match.localTeam.id === teamId
    const teamType = isLocal ? 'localTeam' : 'visitingTeam'
    return teamType
}

export default getTeamType